import "./../../styles.css";
import dayjs from "dayjs";
import { Row, Col, Card, Tag } from "antd";
import { UNITS } from "components/Common/Constants";
import AutomaticTripIcon from "./Icons/AutomaticTrip";
import TestTripIcon from "./Icons/TestTrip";
import NoData from "components/Common/NoData";
import { formatDateAndTime, formatHourAndMins } from "components/Common/Utils";


const TripDetailsCard = ({ tripCardTitle, tripDetails }) => {
  return (
    <Card className="vaCards latest-trip-card" title={tripCardTitle}>
      {tripDetails?.startTime ? (
        <Row align={"middle"} gutter={[12, 12]} className="pd05">
          <Col span={24} className="align-center">
            <span>Start: </span>
            <span className="ml05">{tripDetails?.startAddress || <span className="disabled">NA</span>}</span>
          </Col>
          <Col span={24} className="align-center">
            <span>End: </span>
            <span className="ml05">{tripDetails?.endAddress || <span className="disabled">NA</span>}</span>
          </Col>
          <Col span={24} className="align-center">
            <span>Time: </span>
            <span className="ml05">
              {dayjs(tripDetails?.startTime).date() ===
              dayjs(tripDetails?.endTime).date() ? (
                <div className="align-center">
                  <div className="">
                    {dayjs(tripDetails?.startTime).format("MMM DD YYYY")}
                  </div>
                  <div className="ml05">
                    {dayjs(tripDetails?.startTime).format("hh:mm A")} to{" "}
                    {dayjs(tripDetails?.endTime).format("hh:mm A")}
                  </div>
                </div>
              ) : (
                <>
                  <div className="f12">
                    {formatDateAndTime(tripDetails?.startTime)}
                  </div>
                  <div className="f12">
                    {formatDateAndTime(tripDetails?.endTime)}
                  </div>
                </>
              )}
            </span>
          </Col>
          <Col span={24} className="align-center">
            <span>Type: </span>
            <span className="ml05">
              <Tag
                color={tripDetails?.tripType === "AUTOMATIC" ? "blue" : "green"}
              >
                {tripDetails?.tripType === "AUTOMATIC" ? (
                  <AutomaticTripIcon />
                ) : (
                  <TestTripIcon style={{ fontSize: 12 }} />
                )}
                <span>{tripDetails?.tripType}</span>
              </Tag>
            </span>
          </Col>
          <Col span={24} className="align-center">
            <span>Duration: </span>
            <span className="ml05">
              {formatHourAndMins(tripDetails?.duration)}
            </span>
          </Col>
          <Col span={24} className="align-center">
            <span>Distance: </span>
            <span className="ml05">
              {tripDetails?.distance} {UNITS.KM}
            </span>
          </Col>
        </Row>
      ) : (
        <NoData />
      )}
      {/* <div style={{ minHeight: "90px" }}>
        <p>{vehicleTripsData?.latestTrip?.startAddress} -- {vehicleTripsData?.latestTrip?.endAddress}</p>
        <p>
          Duration {"---"} Distance -- {UNITS.KM}{" "}
        </p>
      </div> */}
    </Card>
  );
};

export default TripDetailsCard;
